import getV3StockMtHistorytradefilterById from '@services/api/stock/history/marginDetail';
import { useQuery } from '@tanstack/react-query';

/**
 * @param {import('@services/api/stock/history/marginDetail').MtHistoryDetail}  objectParams
 */
function useHistoryMtDetail({ idxNo, startDate }) {
  const { cb, key } = getV3StockMtHistorytradefilterById({ idxNo, startDate });

  const { data, isSuccess, isLoading } = useQuery(key, cb, {
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return { data, isSuccess, isLoading };
}

export default useHistoryMtDetail;
